// extracted by mini-css-extract-plugin
module.exports = {"textArea":"textarea_textArea__220iD"};